var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3290",
    "data-name": "Rectangle 3290",
    width: 14,
    height: 14,
    transform: "translate(-0.344 0.088)",
    fill: "#b7b7b7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_167",
    "data-name": "Mask Group 167",
    transform: "translate(0.344 -0.088)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2393",
    "data-name": "Path 2393",
    d: "M12.134,14.355H5.222A2.222,2.222,0,0,1,3,12.133V5.222A2.222,2.222,0,0,1,5.222,3h6.912a2.222,2.222,0,0,1,2.222,2.222v6.912a2.222,2.222,0,0,1-2.222,2.222Z",
    transform: "translate(-0.531 -0.531)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2394",
    "data-name": "Path 2394",
    d: "M4.807,2.338h7.278A2.225,2.225,0,0,0,9.991.857H3.079A2.222,2.222,0,0,0,.857,3.079V9.991a2.225,2.225,0,0,0,1.481,2.095V4.807A2.468,2.468,0,0,1,4.807,2.338Z",
    transform: "translate(-0.857 -0.857)",
    fill: "#b7b7b7",
    opacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/fileIcon.8c7acaec4597f4f6be8c8ee45e556909.svg";
export { ForwardRef as ReactComponent };